/**
 * Web sync-storage adapter. Wraps `localStorage` / `sessionStorage` (or
 * any `Storage`) in the async interface so the lifted modules don't
 * have to branch on platform. Throws synchronously on quota / security
 * errors per the Web Storage API contract; the caller's await chain
 * reflects the rejection.
 */
export function webStorageAdapter(storage) {
    return {
        async getItem(key) {
            return storage.getItem(key);
        },
        async setItem(key, value) {
            storage.setItem(key, value);
        },
        async removeItem(key) {
            storage.removeItem(key);
        },
    };
}
/**
 * In-memory adapter — useful for SSR / server / tests where no real
 * storage exists. Values live for the process lifetime; nothing
 * persists.
 */
export function inMemoryStorageAdapter() {
    const map = new Map();
    return {
        async getItem(key) {
            return map.get(key) ?? null;
        },
        async setItem(key, value) {
            map.set(key, value);
        },
        async removeItem(key) {
            map.delete(key);
        },
    };
}
//# sourceMappingURL=storage.js.map